import { useSuspenseQuery } from '@tanstack/react-query';

import { cacheKeys } from '../config';
import { universityClient } from '../client/universityClient';

type Options = {
};

const defaultOptions: Partial<Options> = {
};

export const useUniversities = (params: Universities.GetListParams = {}, options: Partial<Options> = defaultOptions) => {
  const { data: { data } = {}, ...rest } = useSuspenseQuery({
    queryKey: [cacheKeys.getUniversities, params],
    queryFn: () => universityClient.getUniversities(params),
  });

  return {
    ...rest,
    count: data?.count || 0,
    universities: data?.results || [],
  };
};
